import React from 'react';

import { Button } from '@flywire/headlessui-tailwindcss';
import { CardElement, PayerElement } from '@flywire/internal-react-elements';
import '@flywire/internal-react-elements/styles.css';

import { Box } from 'components/Box/Box';
import { Heading } from 'components/Heading/Heading';
import { Spinner } from 'components/Spinner/Spinner';
import { LoadingDots } from 'components/ui/LoadingDots/LoadingDots';
import { useTranslations } from 'utils/translations/useTranslations';

import './SurchargeCardForm.scss';

const SurchargeCardFormContent = ({
  buttonDisabled,
  isLoading,
  onSubmit,
}: {
  buttonDisabled: boolean;
  isLoading: boolean;
  onSubmit: () => void;
}) => {
  const i18n = useTranslations();

  return (
    <div className="payexCardForm">
      <div className="payexCardForm-content">
        <Heading as="h2" size="large" className="fontWeight-semiBold">
          {i18n.t('cardForm.title')}
        </Heading>
        <Box>
          {isLoading ? (
            <Spinner
              className="payexCardForm-spinner"
              data-testid="cardFormSpinner"
            />
          ) : (
            <div className="payexCardForm-fields">
              <PayerElement className="payexCardForm-payer">
                <PayerElement.FirstName className="payexCardForm-firstName" />
                <PayerElement.LastName />
              </PayerElement>
              <CardElement.CardNumber className="payexCardForm-cardNumber" />
              <div className="payexCardForm-cardDetails">
                <CardElement.ExpiryDate />
                <CardElement.CVV />
              </div>
              <Button
                tone="primary"
                size="full"
                onClick={onSubmit}
                disabled={buttonDisabled}
                data-testid="cardFormSubmitBtn"
              >
                {buttonDisabled ? (
                  <LoadingDots className="h-6 items-center [&>span]:bg-white" />
                ) : (
                  i18n.t('cardForm.pay')
                )}
              </Button>
            </div>
          )}
        </Box>
        <div className="payexCardForm-disclaimer" role="alert">
          {i18n.t('cardForm.disclaimer')}
        </div>
      </div>
    </div>
  );
};

export { SurchargeCardFormContent };
